// Anything passed here should already be in UTC timezone, but we
// want to add a Z if it's not already there to ensure it's treated as such

export function ensureUTCFormatTimestamp(timestamp?: string) {
  if (!timestamp) {
    return new Date().toISOString();
  }
  return timestamp.endsWith('Z') || timestamp.endsWith('+00:00')
    ? timestamp
    : timestamp + 'Z';
}
